<template>
    <page class="page-view">
        <markdown-text class="page-view-content">{{ content }}</markdown-text>
    </page>
</template>

<script>
  import Page         from '../Layout/Page';
  import MarkdownText from '../MarkdownText';

  export default {
    name:       'PageView',
    components: { MarkdownText, Page },

    props: {
      slug: {
        type:     String,
        required: true,
      },
    },

    computed: {
      page () {
        return this.$api.findPageBySlug(this.slug);
      },

      content () {
        return this.page.content;
      },

      title () {
        return this.page.title;
      },
    },
  };
</script>

<style scoped>
    .page-view-content {
        max-width: 72rem;
    }

</style>
